import { render, staticRenderFns } from "./FormPriceBasic.vue?vue&type=template&id=03053191&"
import script from "./FormPriceBasic.vue?vue&type=script&lang=js&"
export * from "./FormPriceBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports